module.exports = __webpack_public_path__ + "img/1367.87915291.png";